import { validate } from 'validate.js';
import { sanitizeZip } from './_register-utils';

const myAyaUrl = document.querySelector('html').dataset.my || `my`
const coreApi = document.querySelector('html').dataset.core || `api`

// const documentVersionNumber = 3;
const documentVersionNumber = parseInt(document.documentElement.dataset.documentversionnumber) || 3;

const hubspotFormId = document.documentElement.dataset.hsformid || ``;
const hubspotProperty = document.documentElement.dataset.hsproperty || ``;


// validate.js regex method (format) is broken with complex regex expressions, custom version to fix it
validate.validators.regex = function (value, options, key, attributes) {
    let regExp = new RegExp(options.pattern);

    if (!regExp.test(value)) {
        return options.message;
    }
};


// These are the constraints used to validate the form
var constraints = {
    firstName: {
        presence: true
    },

    lastName: {
        presence: true
    },

    email: {
        presence: true,
        email: true
    },

    phone: {
        presence: true,
        length: {
            minimum: 14,
            maximum: 20
        }
    },

    country: {
        presence: true,
    },

    zipCode: {
        presence: true,
        length: {
            minimum: 5,
            maximum: 7
        }
    },

    professionCode: {
        presence: {
            message: "^Profession can't be blank"
        }
    },


    // "professionCode:number": {
    //     presence: {
    //         message: "^Profession can't be blank"
    //     }
    // },



    "specialty[][expertiseName]": {
        presence: {
            message: "^Specialty can't be blank"
        }
    },


    "specialty[][expertiseDuration]:number": {
        presence: {
            message: "^Experience can't be blank"
        },
    },

    password: {
        presence: true,
        regex: {
            pattern: "(?=.*?[0-9])(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[!\\[\\]\\{\\}\\\\`~^;:'\"<>\\?\\|,/@#\\$%\\^\\&*\\)\\(+=._-])",
            message: "must contain 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character"
        },
        length: {
            minimum: 8
        }
    },

    confirmPassword: {
        presence: {
            message: "^Password can't be blank"
        },
        equality: {
            attribute: "password",
            message: "^The passwords do not match"
        }
    },


};



export function handleFormSubmit(form) {
    // console.log('handleFormSubmit')
    // validate the form against the constraints
    var errors = validate(form, constraints);
    // then we update the form to reflect the results
    // console.log(errors)
    showErrors(form, errors || {});
    if (!errors) {
        showSuccess();
    }
}

// Updates the inputs with the validation errors
function showErrors(form, errors) {
    // We loop through all the inputs and show the errors for that input
    // let fields = form.querySelectorAll("input[name]:not([type='hidden']), select[name]:not([type='hidden'])")
    let fields = form.querySelectorAll("input[name]:not(.skip-validation), select[name]:not(.skip-validation, #expertiseCode, input:not(#recaptchaResponse))")

    fields.forEach((field) => {
        showErrorsForInput(field, errors && errors[field.name]);
    });

    if (Object.keys(errors).length !== 0) {
        let firstError = document.querySelector('.has-error input').id;
        let firstErrorEl = document.getElementById(firstError)
        scrollTo(firstErrorEl)
        firstErrorEl.focus()
    }

}

// Shows the errors for a specific input
function showErrorsForInput(input, errors) {
    // This is the root of the input
    var formGroup = closestParent(input.parentNode, "field");

    // Find where the error messages will be insert into
    var messages = formGroup.querySelector(".messages");

    // First we remove any old messages and resets the classes
    resetFormGroup(formGroup);
    // If we have errors
    if (errors) {
        // we first mark the group has having errors
        formGroup.classList.add("has-error");
        errors.forEach((error) => {
            addError(messages, error);
        });
    } else {
        // otherwise we simply mark it as success
        formGroup.classList.add("has-success");
    }
}

// Recusively finds the closest parent that has the specified class
function closestParent(child, className) {
    if (!child || child == document) {
        return null;
    }

    if (child.classList.contains(className)) {
        return child;
    } else {
        return closestParent(child.parentNode, className);
    }
}

function resetFormGroup(formGroup) {
    // Remove the success and error classes
    formGroup.classList.remove("has-error");
    formGroup.classList.remove("has-success");
    // and remove any old messages

    let fields = formGroup.querySelectorAll(".help.is-danger")

    fields.forEach((field) => {
        field.parentNode.removeChild(field);
    });

}

// Adds the specified error with the following markup
function addError(messages, error) {
    var block = document.createElement("p");
    block.classList.add("help");
    block.classList.add("is-danger");
    block.innerText = error;
    messages.appendChild(block);
}








function showSuccess() {

    // Form variables
    let formSettings = {
        "thankYouURL": "/register/thank-you/",
        // "hubSpotFormID": "20ba6614-b518-4c58-9c47-4e2e8777b772",
        "hubSpotFormID": hubspotFormId,
        "hubSpotWebProperty": "Shifts",
    };


    jQuery('form .submit button').addClass('is-loading').prop('disabled', true);

    // Grab the page title, URI, and hubspotutk cookie value to send along to HubSpot.
    let pageTitle = document.title;
    let pageUrl = document.URL;
    let hubSpotUtkCookie = getCookie('hubspotutk');

    let formData = jQuery('#register-form').serializeJSON({ useIntKeysAsArrayIndex: true });
    formData.hubSpotUtk = hubSpotUtkCookie;
    formData.formId = formSettings.hubSpotFormID;
    formData.confirmEmail = jQuery('#email').val()
    // formData.portalId = 5133778;
    formData.portalId = hubspotProperty;
    // formData.sourceCode = 277;
    // formData.EmploymentTypeId = 7;
    // fix zipcode losing leading 0s
    formData.zipCode = sanitizeZip(jQuery('#zipCode').val());
    formData.referrerSite = sessionStorage.getItem("referrerSite") === null || sessionStorage.getItem("referrerSite") == "" ? null : sessionStorage.getItem("referrerSite");

    if (document.getElementById("hasAcceptedLatestTerms").checked) {
        formData.documentSignatureInfo = {
            "documentType": 2,
            "documentVersionNumber": documentVersionNumber
        }
    }

    // sms acceptance
    if (document.getElementById("hasAcceptedOptInText").checked) {
        formData.hasAcceptedOptInText = 1
    } else {
        formData.hasAcceptedOptInText = 0
    }

    formData = JSON.stringify(formData);



    // Let's selectively pick the data we're sending to HubSpot. We need to match the data that the HubSpot form is expecting.
    let hsFormData = JSON.stringify({

        "fields": [{
            "name": "firstname",
            "value": jQuery('#firstName').val()
        },
        {
            "name": "lastname",
            "value": jQuery('#lastName').val()
        },
        {
            "name": "email",
            "value": jQuery('#email').val()
        },
        {
            "name": "zipCode",
            "value": jQuery('#zipCode').val()
        },
        {
            "name": "country",
            "value": jQuery('#country option:selected').text()
        },
        {
            "name": "candidate_profession",
            "value": jQuery('.professions-dropdown').find('.text').text()
        },
        {
            "name": "candidate_specialty",
            "value": jQuery('.specialties-dropdown').find('.text').text()
        },
        {
            "name": "phone",
            "value": jQuery('#phone').val()
        },
        {
            "name": "web_property",
            "value": formSettings.hubSpotWebProperty
        },
        {
            "name": "referred_to",
            "value": jQuery('#referredTo').val()
        }
        ],
        "context": {
            "hutk": hubSpotUtkCookie,
            "pageUri": pageUrl,
            "pageName": pageTitle,

        },
        "skipValidation": true,
    });
    

    // Setup to send!
    var applicationForm = {
        "async": true,
        "crossDomain": true,
        "url": `https://${coreApi}.ayahealthcare.com/shifts/account/user`,
        "method": "POST",
        "headers": {
            "Content-Type": "application/json",
            "aya-app-id": "9",
        },
        "processData": false,
        "data": formData,
        "success": function (response) {
            console.log('Aya registration success');


            jQuery('.notification.is-danger').addClass('hide-el').html('');


            // Push to dataLayer
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'web_registration',
                'userEmail': jQuery('#email').val(),
                'userPhone': '+1' + jQuery('#phone').val().replace(/[^0-9]/g, ''),
                'userCountry': jQuery('#country').val(),
                'userProfessionCode': jQuery('#professionCode').val(),
                'userProfessionText': jQuery('.profession-dropdown').find('.text').text(),
                'userExpertiseCode': jQuery('[data-input="expertiseCode"').val(),
                'userExpertiseText': jQuery('.expertise-dropdown').find('.text').text(),
                'userNameFirst': jQuery('#firstName').val(),
                'userNameLast': jQuery('#lastName').val(),
                'userExperience': jQuery('.experience-dropdown').find('.text').text()
            });

            // Send the data to HubSpot.
            jQuery.ajax({
                "async": true,
                "crossDomain": true,
                "type": "POST",
                "url": `https://api.hsforms.com/submissions/v3/integration/submit/${hubspotProperty}/${formSettings.hubSpotFormID}`,
                "headers": {
                    "Content-Type": "application/json"
                },
                "data": hsFormData,
                "error": function (response) {
                    console.log('There was a HS Forms error.');

                    // Change the button back to "APPLY".
                    //   defaultSubmitButton();
                },
                "success": function () {
                    console.log('Hubspot success');
                    // Upon a success return from HubSpot, send the HubSpot data to Aya's V1 so we can sync the data later.
                    jQuery.ajax({

                        "async": true,
                        "crossDomain": true,
                        "type": "POST",
                        "url": `https://${coreApi}.ayahealthcare.com/LocumsWeb/Account/hubspot-source`,
                        "headers": {
                            "Content-Type": "application/json"
                        },
                        "data": formData,
                        "error": function (response) {
                            console.log(`There was an error from Aya's hubspot-source endpoint.`);

                            var errorMessage = response.responseJSON
                                ? response.responseJSON.errors.message
                                : response.responseText

                            jQuery(".notification.is-danger").html('There seems to be an error with your application. ' + errorMessage);
                            jQuery('.notification.is-danger').removeClass('hide-el');

                        },
                        "success": function () {
                            console.log(`Aya's hubspot-source was successful.`);

                            // create variables to collect the profession and specialty data selected
                            let formProfession = document.querySelector('#professionCode').value;
                            let formSpecialty = document.querySelector('input[data-input="expertiseCode"]').value;

                            // Redirect to the thank-you page.
                            window.location.href = `${formSettings.thankYouURL}?profession=${formProfession}&specialty=${formSpecialty}`;
                        },
                    });

                }
            });
        },
        "error": function (response) {

            console.log('Something went wrong with your submission. There should be an error displayed on the page.');

            jQuery('form .submit button').removeClass('is-loading').prop('disabled', false);

            if (response.responseJSON) {
                if (response.responseJSON.error_code == 2210) {

                    //console.log(response.responseJSON.error_description);
                    // Custom error message will populate the error container.
                    jQuery(".notification.is-danger").html(`Thank you for your interest in Shifts. We found your profile in our parent company's database (Aya Healthcare). Please email <a style="text-transform: none; text-decoration: underline; color: #272727;" href="mailto:hello@shifts.com">hello@shifts.com</a> or call <a href="tel:8666877390" style="text-transform: none; white-space: nowrap; text-decoration: underline; color: #272727;">(866) 687-7390</a> so we can finish your Shifts application and get you working! We look forward to hearing from you.</p>`);
                    jQuery('.notification.is-danger').removeClass('hide-el');

                    // Push to dataLayer
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        'event': 'duplicate_registration_attempt',
                        'userEmail': jQuery('#email').val()
                    });

                }
                // Return custom zoinks error message if error_code 2210 (duplicate email) is returned from the API.
                else if (response.status == 400) {
                    let errorsString = '';
                    if (response.responseJSON.errors) {
                        let errors = response.responseJSON.errors;

                        for (const error in errors) {
                            errorsString += errors[error] + '<br>';
                        }
                    }

                    else if (response.responseJSON.error) {
                        let error = response.responseJSON.error;
                        errorsString = error;
                    }

                    else {
                        errorsString = '';
                    }

                    jQuery(".notification.is-danger").html("Oops! There's an error with your application.<br> " + errorsString);
                    jQuery('.notification.is-danger').removeClass('hide-el');
                }

            }
            else {
                let errorRes = (response.responseText !== undefined) ? response.responseText : '';
                jQuery(".notification.is-danger").html("Oops! There's an error with your application.<br> " + errorRes);
                jQuery('.notification.is-danger').removeClass('hide-el');

            }
        }
    };

    // Send the application form.
    jQuery.ajax(applicationForm).done(function (response) {

    });

}